/**
 * The identity-provider seam. `VITE_HOSTINGPORTAL_AUTH_PROVIDER` picks which hosted IdP
 * the live login flow talks to — `identity-platform` (GCP, the default) or
 * `cognito` (the legacy AWS path). Both bundles expose the same shape, so the
 * login/signup pages import from here and never branch on the provider.
 *
 * Local dev and mock mode short-circuit before any of this runs (see
 * `login.tsx`), so the selected provider only matters for production builds.
 */

import { cognitoProvider } from './cognito'
import { identityPlatformProvider } from './identity-platform'

export type AuthProviderName = 'identity-platform' | 'cognito'

const PROVIDER: AuthProviderName =
  (import.meta.env.VITE_HOSTINGPORTAL_AUTH_PROVIDER as AuthProviderName | undefined) ?? 'identity-platform'

const active = PROVIDER === 'cognito' ? cognitoProvider : identityPlatformProvider

export const authProviderName = PROVIDER

// Concrete functions + error classes from the selected provider. The classes are
// re-exported as values so `instanceof AuthError` in the UI matches whatever the
// active provider actually throws.
export const signIn = active.signIn
export const activateInvitedUser = active.activateInvitedUser
export const completeNewPasswordChallenge = active.completeNewPasswordChallenge
/** Silent token refresh (refresh-token → fresh ID token) for persistent logins. */
export const refresh = active.refresh
export const AuthError = active.AuthError
export const NewPasswordRequiredError = active.NewPasswordRequiredError
